<template>
  <section id="section__signup" class="view-container" :class="{ mobile: isMobile }">
    <keep-alive>
      <router-view :user="registerForm" id="btn__LABSjqoaIUK2bMXGBAj5Q"></router-view>
    </keep-alive>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('signup', { registerForm: 'getRegisterForm' }),
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
  },
}
</script>
